module.exports = __webpack_public_path__ + "img/img6.94218a95.png";